/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const command = {
  command: "login",
  describe: "Authenticate with an application ID",
  builder: argv => {
    return argv.option("clientId", {
      alias: "applicationId",
      // for backwards compatibility
      type: "string",
      demandOption: true,
      describe: "OAuth client ID for application"
    });
  },
  handler: async args => {
    const command = await import("@osdk/cli.common/loginFlow");
    await command.default(args);
  }
};
export default command;